import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export enum Cache {
  Customers = 'Customers',
  Subscriptions = 'Subscriptions',
  Countries = 'Countries',
  Schools = 'Schools',
  Footer = 'Footer',
  Header = 'Header',
  Account = 'Account',
  Search = 'Search',
}

const baseUrl = import.meta.env.MODE === 'test' ? import.meta.env.VITE_BASE_URL : '';

export const api = createApi({
  baseQuery: fetchBaseQuery({
    prepareHeaders: (headers) => {
      headers.set('X-CSRF', '1');
      return headers;
    },
    baseUrl,
  }),
  // We don't define any endpoints here. They are injected from separate files.
  endpoints: () => ({}),
  tagTypes: Object.values(Cache),
});
